export class HeaderItem {
  constructor(
    public text: string,
    public route?: string,
    public children?: Array<HeaderItem>,
    public link?: string
  ) {}
}
